export interface SalutationFieldsConfig {
  translations: SalutationFieldsTranslation[];
}

export enum GeneralTitleValue {
  Mr = 'mr',
  Ms = 'ms',
  None = 'none',
}

export interface GeneralTitleOption {
  label: string;
  value: GeneralTitleValue;
}

export enum ProfessionalTitleValue {
  Dr = 'dr',
  Prof = 'prof',
  None = 'none',
  MrDr = 'mr_dr',
  MrProf = 'mr_prof',
  MsDr = 'ms_dr',
  MsProf = 'ms_prof',
}

export interface ProfessionalTitleOption {
  label: string;
  value: ProfessionalTitleValue;
}

export interface GreetingsItem {
  label: string;
  value: string;
}

interface SalutationFieldsTranslation {
  langCode: string;
  titles: ProfessionalTitleOption[];
  salutations: GeneralTitleOption[];
  greetings: GreetingsItem[];
}
